import axios from "axios";
import { getUtm } from "../utils/utm";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000, withCredentials: true });

// attach bearer token if present
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("viralya-token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export async function fetchConfig() {
  const { data } = await api.get("/config");
  return data;
}
export async function fetchContent() {
  const { data } = await api.get("/content");
  return data;
}
export async function submitLead(payload) {
  const { data } = await api.post("/leads", { ...payload, utm: getUtm() });
  return data;
}
export async function submitAudit(payload) {
  const { data } = await api.post("/audit", { ...payload, utm: getUtm() });
  return data;
}
export async function submitPartner(payload) {
  const { data } = await api.post("/partners", { ...payload, utm: getUtm() });
  return data;
}
export async function challengeSignup(payload) {
  const { data } = await api.post("/challenge/signup", { ...payload, utm: getUtm() });
  return data;
}
export async function logConsent(choix, categories) {
  const { data } = await api.post("/consent", {
    choix, categories,
    user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
  });
  return data;
}
export async function fetchAngles() {
  const { data } = await api.get("/angles");
  return data;
}
export async function fetchAngle(slug) {
  const { data } = await api.get(`/angles/${slug}`);
  return data;
}
export async function createOrder(payload) {
  const { data } = await api.post("/orders", payload);
  return data;
}
export async function getOrder(id) {
  const { data } = await api.get(`/orders/${id}`);
  return data;
}
export async function payOrder(id) {
  const { data } = await api.post(`/orders/${id}/pay`);
  return data;
}
export async function startCheckout(payload) {
  const { data } = await api.post("/checkout", { ...payload, utm: getUtm(), origin_url: window.location.origin });
  return data;
}
export async function paymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
}
export async function upsellOrder(orderId) {
  const { data } = await api.post(`/orders/${orderId}/upsell`);
  return data;
}
export async function declineUpsell(orderId) {
  const { data } = await api.post(`/orders/${orderId}/upsell/decline`);
  return data;
}
export async function onboardingStep(orderId, step, payload) {
  const { data } = await api.post(`/orders/${orderId}/onboarding/${step}`, payload || {});
  return data;
}
export async function fetchOrder(orderId) {
  const { data } = await api.get(`/orders/${orderId}`);
  return data;
}
export async function uploadProof(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload-proof", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}
export const BACKEND = BACKEND_URL;

// auth
export async function login(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  if (data.token) localStorage.setItem("viralya-token", data.token);
  return data;
}
export async function me() {
  const { data } = await api.get("/auth/me");
  return data;
}
export async function logout() {
  try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
  localStorage.removeItem("viralya-token");
}

// admin
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminLeads = () => api.get("/admin/leads").then((r) => r.data);
export const adminOrders = () => api.get("/admin/orders").then((r) => r.data);
export const adminConfig = () => api.get("/admin/config").then((r) => r.data);
export const adminUpdateConfig = (body) => api.put("/admin/config", body).then((r) => r.data);
export const adminAngles = () => api.get("/admin/angles").then((r) => r.data);
export const adminPartners = () => api.get("/admin/partners").then((r) => r.data);
export const adminContent = () => api.get("/admin/content").then((r) => r.data);
export const adminUpdateContent = (body) => api.put("/admin/content", body).then((r) => r.data);
export const adminChallenge = () => api.get("/admin/challenge").then((r) => r.data);
export const adminAudits = () => api.get("/admin/audits").then((r) => r.data);
export const setBilanStatus = (id, envoye) => api.post(`/admin/leads/${id}/bilan-status`, { envoye }).then((r) => r.data);
export const adminCreateAngle = (body) => api.post("/admin/angles", body).then((r) => r.data);
export const adminUpdateAngle = (id, body) => api.put(`/admin/angles/${id}`, body).then((r) => r.data);
export const adminDeleteAngle = (id) => api.delete(`/admin/angles/${id}`).then((r) => r.data);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Merci de réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}
